"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Table = _interopRequireDefault(require("../table/Table"));

var ImportErrors = function ImportErrors(_ref) {
  var errors = _ref.errors;
  var model = [{
    header: 'Row',
    accessor: 'row',
    size: 'xs'
  }, {
    header: 'Column name',
    accessor: 'type'
  }, {
    header: 'Error',
    accessor: 'error'
  }];
  return (0, _preact.h)("div", {
    className: "import-errors"
  }, (0, _preact.h)("h3", null, "Errors"), (0, _preact.h)(_Table.default, {
    model: model,
    rows: errors
  }));
};

var _default = ImportErrors;
exports.default = _default;